import { DEFAULT_TRANSITION_TIMEOUT } from '@utils/variables';
import { FC, useId } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { StyledErrorText, StyledLabel, StyledSwitch, StyledSwitchTrack, StyledSwitchWrapper } from './Switch.styles';
import { ISwitch } from './Switch.type';

const Switch: FC<ISwitch> = ({
	dataCy,
	isChecked,
	setIsChecked,
	onClick,
	label,
	customId,
	errorUUID = 'unset',
	errorMessage,
	disabled = false
}) => {
	const id = useId();

	return (
		<>
			<StyledSwitchWrapper onClick={onClick}>
				<StyledSwitch
					id={customId || id}
					data-cy={dataCy}
					type='checkbox'
					onChange={(event) => setIsChecked(event.target.checked)}
					checked={isChecked}
					disabled={disabled}
				/>
				<StyledSwitchTrack htmlFor={customId || id} />
				<StyledLabel htmlFor={customId || id}>{label}</StyledLabel>
			</StyledSwitchWrapper>

			<SwitchTransition>
				<CSSTransition key={errorUUID} classNames='fade' timeout={DEFAULT_TRANSITION_TIMEOUT['100']}>
					<StyledErrorText>{errorMessage}</StyledErrorText>
				</CSSTransition>
			</SwitchTransition>
		</>
	);
};

export { Switch };
